import { runDemo } from "../shared/demoRunner";
import { createFlat2009Scene } from "./scene";

runDemo({ createScene: createFlat2009Scene });
